import { DOCUMENT } from '@angular/common';
import {
    Inject,
    Injectable,
} from '@angular/core';

import camelCase from 'lodash-es/camelCase';

import { Color } from './theme.type';

const convertToAppTheme = (theme: any): Color.ITheme | undefined => {
    if (!theme) { return; }

    const appTheme: any = {};
    for (const key of Object.keys(theme)) {
        if (key.includes('-contrast')) { continue; }

        appTheme[camelCase(key)] = typeof theme[key] === 'object' ?
            convertToAppTheme(theme[key])
            : theme[key];
    }
    return appTheme as Color.ITheme;
};

const THEME_MAP: Record<string, Color.ITheme> = {};

@Injectable({
    providedIn: 'root',
})
export class ColorService {
    private _window?: Window;

    constructor(
        @Inject(DOCUMENT)
        private _document: Document,
    ) { }

    public getColor(color: Color.IColorSet): string {
        return this.theme.colors[color];
    }

    public get theme(): Color.ITheme {
        const themeKey = this._document.body.dataset['theme']!;

        if (THEME_MAP[themeKey]) {
            return THEME_MAP[themeKey];
        }

        this._window = this._document.defaultView!;

        const colorJson = this._window.getComputedStyle(this._document.body, '::before').content;

        const colors = JSON.parse(this._normalizeJson(colorJson));

        return THEME_MAP[themeKey] = convertToAppTheme(colors)!;
    }

    // Reference: https://css-tricks.com/making-sass-talk-to-javascript-with-json/
    private _normalizeJson(json: any) {
        // normalize browser inconsistencies
        if (typeof json === 'string' || json instanceof String) {
            json = json.replace(/^['"]+|\s+|\\|(;\s?})+|['"]$/g, '');
        }
        return json;
    }
}

